
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const layoutApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listLayouts: builder.query ({
      query: (params) => `v2/layout/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["Layout"]
    }),
    getLayout: builder.query ({
      query: (layout_id) => `v2/layout/${layout_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["Layout"]
    }),
    getLayoutActions: builder.query ({
      query: (layout_id) => `v2/action/?layout=${layout_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Action"]
    }),
    getLayoutNotes: builder.query ({
      query: (layout_id) => `v2/note/?layout=${layout_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Note"]
    }),
    getLayoutDesigns: builder.query ({
      query: (layout_id) => `v2/designinlayout/?layout=${layout_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["DesignInLayout"]
    }),
    getLayoutCombos: builder.query ({
      query: (layout_id) => `v2/comboinlayout/?layout=${layout_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["ComboInLayout"]
    }),
    updateLayout: builder.mutation ({
      query: ({layout_id, data}) => ({
        url: `v2/layout/${layout_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["Layout"]
    }),
    deleteLayout: builder.mutation ({
      query: (layout_id) => ({
        url: `v2/layout/${layout_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["Layout"]
    }),
    createLayout: builder.mutation ({
      query: (data) => ({
        url: `v2/layout/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Layout"]
    }),
  })
})


export const {
  useListLayoutsQuery,
  useLazyListLayoutsQuery,
  useGetLayoutQuery,
  useLazyGetLayoutQuery,
  useGetLayoutActionsQuery,
  useGetLayoutNotesQuery,
  useGetLayoutDesignsQuery,
  useGetLayoutCombosQuery,
  useUpdateLayoutMutation,
  useDeleteLayoutMutation,
  useCreateLayoutMutation
} = layoutApi
